// React imports
import React, { Component } from 'react';
import PropTypes from 'prop-types'
import {Route, Redirect, Switch} from 'react-router-dom';
import * as firebase from 'firebase';
import queryString from 'query-string';

// internal imports
import AmpModule from '../AmpModule';
import PoiModule from '../PoiModule';

import ApplicationBar from '../../components/ApplicationBar';
import PeriscopeDash from '../PeriscopeDash';
import HomePage from '../HomePage';
import Promos from '../Promos';
import UserAdmin from '../UserAdmin';
import NoMatch from '../NoMatch';

// import assets
import './App.css';

// OPTIONS:
// * implement Helmet for HEAD management: https://github.com/nfl/react-helmet

/**
 * Renders the ApplicationBar and module route when `this.readyToRender()`
 */
class App extends Component {
  static contextTypes = {
    datasets: PropTypes.object.isRequired,
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  /**
   * Defined context types to define what is shared with child components
   *
   * NOTE: Using the Context is considered bad practise, but the alternative is to use Redux, which slightly increases
   *       the complexity of the app. For now this will do.
   *
   * @see getChildContext
   */
  static childContextTypes = {
    dataset: PropTypes.string,
    datasetLocation: PropTypes.string,
    firebaseToken: PropTypes.string,
    history: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    let {dataset, datasetLocation} = this.getDatasetFromContext(context);

    this.state = {
      dataset,
      datasetLocation,
      firebaseToken: '',
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.trySetInitialDataset(nextContext);
  }

  getDatasetFromContext(context) {
    const { location } = this.props;
    const { dataset } = queryString.parse(location.search);
    const datasetKeys = Object.keys(context.datasets);

    let selectedDataset;

    if (datasetKeys.length) {
      // Use the dataset from the URL if allowed, otherwise use the first one in the dataset list.
      selectedDataset = datasetKeys.indexOf(dataset) !== -1 ?
        dataset :
        datasetKeys[0];
    }
    return {
      dataset: selectedDataset,
      datasetLocation: context.datasets[selectedDataset].location || 'eu',
    }
  }

  trySetInitialDataset(context) {
    if (this.state.dataset !== undefined) {
      return;
    }
    const {dataset, datasetLocation} = this.getDatasetFromContext(context);
    this.setState({
      dataset,
      datasetLocation,
    });
  }

  componentWillMount() {
    this.refreshFirebaseToken(true);
    this.firebaseTokenRefreshIv = setInterval(this.refreshFirebaseToken, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.firebaseTokenRefreshIv);
  }

  refreshFirebaseToken = (forceRefresh = false) => {
    // Get the JWT token needed for verification with the backend and make it available on the Context
    firebase.auth().currentUser.getIdToken(forceRefresh)
      .then(this.firebaseTokenChangeHandler)
      .catch(error => {
        this.firebaseTokenChangeHandler(''); // don't know if needed.. reset the jwt token in case of an error.
        console.error(error);
      });
  }

  firebaseTokenChangeHandler = (jwtToken) => {
    if (jwtToken !== this.state.firebaseToken) {
      this.setState({ firebaseToken: jwtToken });
    }
  }

  /**
   * Handle dataset selector changes that come from the AppBar component
   */
  datasetChangeHandler = (newDataset) => {
    const datasetLocation = this.context.datasets[newDataset].location || 'eu';
    this.setState({ dataset: newDataset, datasetLocation});
    // console.log(this.context.datasets);
  }

  /**
   * We are using the context at the moment, because I didn't want to overly complicate our React setup. At some point
   * we'll get rid of the context and will start using stores (redux) to add access to stores instead.
   */
  getChildContext() {
    return {
      dataset: this.state.dataset,
      datasetLocation: this.state.datasetLocation,
      firebaseToken: this.state.firebaseToken,
      history: this.props.history,
    };
  }

  readyToRender() {
    return !!this.state.dataset && !!this.state.firebaseToken
  }

  render() {
    if (!this.readyToRender()) {
      return null;
    }
    return (
      <div className="App">
        <ApplicationBar dataset={this.state.dataset} onDatasetChange={this.datasetChangeHandler} />

        <div className="MainContainer">
          <AppInnerRouter/>
        </div>
      </div>
    );
  }
}

const AppInnerRouter = () => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="/home" push />} />
    <Route path="/amp" component={AmpModule} />
    <Route path="/poi" component={PoiModule} />
    <Route path="/home" component={HomePage} />
    <Route path="/dash" component={PeriscopeDash} />
    <Route path="/explore" component={Promos} />
    <Route path="/admin/users" component={UserAdmin} />
    <Route path="*" component={NoMatch} />
  </Switch>
)

export { App as default, AppInnerRouter};



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx